export function stopYandexMetrika() {
	if (typeof window === 'undefined') return
	delete (window as any).__ymInited
	delete (window as any).ym
	document.querySelectorAll('script[src*="mc.yandex.ru"]').forEach((s) => s.remove())
}

export function initYandexMetrika() {
	if (typeof window === 'undefined' || (window as any).__ymInited) return
	;(window as any).__ymInited = true

	;(function (m: any, e: Document, t: string, r: string, i: string) {
		m[i] =
			m[i] ||
			function (...args: unknown[]) {
				;(m[i].a = m[i].a || []).push(args)
			}
		m[i].l = 1 * new Date().getTime()
		for (let j = 0; j < e.scripts.length; j++) {
			if (e.scripts[j].src === r) return
		}
		const k = e.createElement(t) as HTMLScriptElement
		const a = e.getElementsByTagName(t)[0]
		k.async = true
		k.src = r
		a.parentNode?.insertBefore(k, a)
	})(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

	;(window as any).ym(93475901, 'init', {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
		webvisor: true,
	})
}

export function bindYandexMetrikaUserId(userId: string) {
	if (typeof window === 'undefined' || !userId) return
	ym(93475901, 'setUserID', userId)
	ym(93475901, 'userParams', { UserID: userId })
}
